// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import partNumberSearchCriteria from './criteria';
import report from './report';
import showNoResultsFound from '../../shared/reducers/show-no-results-found';

export const getCombinedReducers = () =>
    combineReducers({
        busyCounter,
        partNumberSearchCriteria,
        report,
        showNoResultsFound
    });



// WEBPACK FOOTER //
// ./src/reports/emissions-part-search/reducers/index.js